import clsx from "clsx";

// Constantes de mensagens
export const LOGIN_MESSAGES = {
  title: "raro.digital",
  subtitle: "Faça login para acessar o sistema",
  signInButton: "Entrar com Google",
  signInMicrosoftButton: "Entrar com Microsoft",
  loading: "Carregando...",
  footer: "Feito em BH com 🧀",
  linkInfoTitle: "Migração necessária",
  linkInfoDescription:
    "Clique em “Entrar com Google” para vincular sua conta existente antes de finalizar a migração para Microsoft.",
} as const;

// Ícone do Google (SVG path)
export const GOOGLE_ICON_PATH =
  "M12.545,10.239v3.821h5.445c-0.712,2.315-2.647,3.972-5.445,3.972c-3.332,0-6.033-2.701-6.033-6.032s2.701-6.032,6.033-6.032c1.498,0,2.866,0.549,3.921,1.453l2.814-2.814C17.503,2.988,15.139,2,12.545,2C7.021,2,2.543,6.477,2.543,12s4.478,10,10.002,10c8.396,0,10.249-7.85,9.426-11.748L12.545,10.239z";

// Ícone do Microsoft (SVG path)
export const MICROSOFT_ICON_PATH =
  "M4 4h8v8H4zM12 4h8v8h-8zM4 12h8v8H4zM12 12h8v8h-8z";

// Função para classes do container principal
export function getContainerClasses(): string {
  return clsx(
    "min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8",
    "bg-gradient-to-br from-primary-50 via-white to-primary-100"
  );
}

// Função para classes do card
export function getCardClasses(): string {
  return clsx(
    "bg-white rounded-2xl p-8 border border-primary-100",
    "shadow-raro-lg hover:shadow-raro transition-all duration-200"
  );
}

// Função para classes de estados de loading
export function getLoadingContainerClasses(): string {
  return clsx(
    "min-h-screen flex items-center justify-center",
    "bg-gradient-to-br from-primary-50 to-raro-blue/10"
  );
}
